/**
 * @generated SignedSource<<cbfb1de35688f136b7345c250dfd76bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineDetailScreenTaskActivity_Routine$data = {
  readonly taskActivityByHour: ReadonlyArray<{
    readonly count: number;
    readonly hour: number;
  }>;
  readonly " $fragmentType": "RoutineDetailScreenTaskActivity_Routine";
};
export type RoutineDetailScreenTaskActivity_Routine$key = {
  readonly " $data"?: RoutineDetailScreenTaskActivity_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineDetailScreenTaskActivity_Routine">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineDetailScreenTaskActivity_Routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineTaskActivityByHour",
      "kind": "LinkedField",
      "name": "taskActivityByHour",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hour",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};

(node as any).hash = "97b41c107d6aed8720616ea7525792be";

export default node;
